module.exports = __webpack_public_path__ + "images/aveco_smallcce64fdcd1cae929c9ef15dff6bdcd24.png";